/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useGetBlobPresignedUrl
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';

type IProps = {
	blobCategory: S3BlobCategory;
	entityType?: EntityTypeEnum;
};
/**
 * useGetBlobPresignedUrl
 * @returns {UseMutationResult} useGetBlobPresignedUrl
 */
const useGetBlobPresignedUrl = (): UseMutationResult<PresignedUrlResponse, IAxiosError, IProps, unknown> => {
	return useMutation({
		mutationFn: async (params) => {
			const { data } = await api.BlobDataApi.getPresignedUrl(params);
			return data;
		},
	});
};

export default useGetBlobPresignedUrl;
